import React from "react";
import { ProcManagementR } from "../../pages/proc-management/route";
import { TtzkPortalR } from "../../pages/ttzk-portal/route";
import { NavLink, useRouteMatch } from "react-router-dom";
import {
  MenuList as GCDKMenuList,
  SectionItemType,
} from "@graffer-inc/console-design-kit";
import { useRBAC } from "../../helpers/rbac/use-rbac";

export const MenuList: React.FC = () => {
  const hasPermission = useRBAC();
  const { path } = useRouteMatch();

  const procManagementMenuList: SectionItemType = {
    header: "手続きマスタ管理",
    navItems: [
      {
        title: "手続き一覧",
        hidden: !hasPermission({
          requirePermissions: "proc_management.procedures.list",
        }),
        active: path === ProcManagementR.ProcedureList.link({}),
        anchor: (props) => (
          <NavLink
            {...props}
            to={ProcManagementR.ProcedureList.link({})}
          ></NavLink>
        ),
      },
      {
        title: "場所データ一覧",
        hidden: !hasPermission({
          requirePermissions: "proc_management.places.list",
        }),
        anchor: (props) => (
          <NavLink {...props} to={ProcManagementR.PlaceList.link({})}></NavLink>
        ),
        active: path === ProcManagementR.PlaceList.link({}),
      },
      {
        title: "手続きタグ一覧",
        hidden: !hasPermission({
          requirePermissions: "proc_management.procedure_tags.list",
        }),
        anchor: (props) => (
          <NavLink
            {...props}
            to={ProcManagementR.ProcedureTagList.link({})}
          ></NavLink>
        ),
        active: path === ProcManagementR.ProcedureTagList.link({}),
      },
      {
        title: "検索設定",
        hidden: !hasPermission({
          requirePermissions: "proc_management.search_config.read",
        }),
        anchor: (props) => (
          <NavLink
            {...props}
            to={ProcManagementR.ConfigEdit.link({})}
          ></NavLink>
        ),
        active: path === ProcManagementR.ConfigEdit.link({}),
      },
    ],
  };

  return (
    <GCDKMenuList
      items={[
        {
          header: "ポータル管理",
          navItems: [
            {
              title: "ショートカット一覧",
              hidden: !hasPermission({
                requirePermissions: "ttzk_portal.shortcuts.list",
              }),
              anchor: (props) => (
                <NavLink
                  {...props}
                  to={TtzkPortalR.ShortcutList.link({})}
                ></NavLink>
              ),
              active: path === TtzkPortalR.ShortcutList.link({}),
            },
            {
              title: "お知らせ情報一覧",
              hidden: !hasPermission({
                requirePermissions: "portal.notices.list",
              }),
              anchor: (props) => (
                <NavLink
                  {...props}
                  to={TtzkPortalR.NoticeList.link({})}
                ></NavLink>
              ),
              active: path === TtzkPortalR.NoticeList.link({}),
            },
            {
              title: "公開設定",
              hidden: !hasPermission({
                requirePermissions: "portal.common_config.read",
              }),
              anchor: (props) => (
                <NavLink
                  {...props}
                  to={TtzkPortalR.ConfigEdit.link({})}
                ></NavLink>
              ),
              active: path === TtzkPortalR.ConfigEdit.link({}),
            },
          ],
        },
        procManagementMenuList,
      ]}
    />
  );
};

export default MenuList;
